import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './themeSlice';
import languageReducer from './languageSlice';
import hoverReducer from './hoverSlice';

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    language: languageReducer,
    hover: hoverReducer,
  },
});

export default store;